export const ACT_TRACE_GET_REQUEST = 'ACT_TRACE_GET_REQUEST';
export const ACT_TRACE_GET_SUCCESS = 'ACT_TRACE_GET_SUCCESS';
export const ACT_TRACE_GET_ERROR = 'ACT_TRACE_GET_ERROR';
export const ACT_TRACE_GET_BY_KEY_REQUEST = 'ACT_TRACE_GET_BY_KEY_REQUEST';
export const ACT_TRACE_GET_BY_KEY_SUCCESS = 'ACT_TRACE_GET_BY_KEY_SUCCESS';
export const ACT_TRACE_GET_BY_KEY_ERROR = 'ACT_TRACE_GET_BY_KEY_ERROR';
export const ACT_TRACE_ADD_REQUEST = 'ACT_TRACE_ADD_REQUEST';
export const ACT_TRACE_ADD_SUCCESS = 'ACT_TRACE_ADD_SUCCESS';
export const ACT_TRACE_ADD_ERROR = 'ACT_TRACE_ADD_ERROR';
export const ACT_TRACE_EDIT_REQUEST = 'ACT_TRACE_EDIT_REQUEST';
export const ACT_TRACE_EDIT_SUCCESS = 'ACT_TRACE_EDIT_SUCCESS';
export const ACT_TRACE_EDIT_ERROR = 'ACT_TRACE_EDIT_ERROR';
export const ACT_TRACE_DELETE_REQUEST = 'ACT_TRACE_DELETE_REQUEST';
export const ACT_TRACE_DELETE_SUCCESS = 'ACT_TRACE_DELETE_SUCCESS';
export const ACT_TRACE_DELETE_ERROR = 'ACT_TRACE_DELETE_ERROR';
